"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var invariant = require("invariant");
var bypass_1 = require("./exist/bypass");
var messages_1 = require("./exist/messages");
var utils_1 = require("./helper/utils");
/**
 * @param funcs validator functions which return error message or false if there's no error
 */
function compose() {
    var _this = this;
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    var funcsLength = funcs.length;
    // compose will accept at least one function. Otherwise, it's no point of using it.
    invariant(funcsLength !== 0, 'Kya: at least one function should be passed in');
    if (funcsLength === 1) {
        // tslint:disable-next-line:variable-name
        return function (arg, BYPASS_FLAG, errorMsg) {
            return __awaiter(this, void 0, void 0, function () {
                var result, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // if required mode is not turned on, we bypass empty condiction in each type of
                            // validation.
                            if (bypass_1.isEmpty(arg) && bypass_1.default(BYPASS_FLAG)) {
                                return [2 /*return*/, { valid: true }];
                            }
                            // if arg is empty and bypassing is turned off, we return field required error.
                            if (bypass_1.isEmpty(arg) && !bypass_1.default(BYPASS_FLAG)) {
                                return [2 /*return*/, {
                                        message: errorMsg || messages_1.default.required,
                                        valid: false,
                                    }];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, funcs[0](arg)];
                        case 2:
                            result = _a.sent();
                            if (utils_1.isObject(result)) {
                                return [2 /*return*/, {
                                        message: result.message,
                                        valid: false,
                                    }];
                            }
                            return [2 /*return*/, {
                                    valid: true
                                }];
                        case 3:
                            e_1 = _a.sent();
                            return [2 /*return*/, invariant(false, "Kya: " + e_1)];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
    }
    // Abstract array of validation functions as one function ready to take argument to be validated.
    return funcs.reduceRight(function (a, b, index) { return function (arg, BYPASS_FLAG, errorMsg) { return __awaiter(_this, void 0, void 0, function () {
        var bout, aout, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if required mode is not turned on, we bypass empty condiction in each type of
                    // validation.
                    if (bypass_1.isEmpty(arg) && bypass_1.default(BYPASS_FLAG)) {
                        return [2 /*return*/, { valid: true }];
                    }
                    // if arg is empty and bypassing is turned off, we return field required error.
                    if (bypass_1.isEmpty(arg) && !bypass_1.default(BYPASS_FLAG)) {
                        return [2 /*return*/, {
                                message: errorMsg || messages_1.default.required,
                                valid: false,
                            }];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, b(arg)];
                case 2:
                    bout = _a.sent();
                    if (utils_1.isObject(bout)) {
                        return [2 /*return*/, {
                                message: bout.message,
                                valid: false
                            }];
                    }
                    return [4 /*yield*/, a(arg)];
                case 3:
                    aout = _a.sent();
                    // If it's the last item and there's no error, we end up returning valid = true
                    if (funcsLength - 2 === index) {
                        if (utils_1.isObject(aout)) {
                            return [2 /*return*/, {
                                    message: aout.message,
                                    valid: false
                                }];
                        }
                        return [2 /*return*/, {
                                valid: true,
                            }];
                    }
                    return [2 /*return*/, aout];
                case 4:
                    e_2 = _a.sent();
                    invariant(false, "Kya: " + e_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }; });
}
exports.default = compose;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/compose.js
// module id = 62
// module chunks = 0